export enum ErrorCodeList {
  CrmSearchError = 'CRM_SEARCH_ERROR',
  OAuthUnauthorized = 'ERR_OAUTH_UNAUTHORIZED',
  RoomAccessDenied = 'ERR_ROOM_ACCESS_DENIED',
  CallAiMeetingDeleted = 'ERR_CALL_AI_MEETING_DELETED',
  // @see https://gitlab.com/mindtickle/dsr/dsr-core-api/-/blob/track/integration/app/graphql/public/queries/rooms/get_room.rb#L15
  RoomDeleted = 'The room has been deleted.',
  Unauthenticated = 401,
  Unauthorized = 403,
}

export const SHELL_ERROR_LOGGER_CONFIG = {
  stream: 'dsr',
  projectType: 'WebLearner',
  appName: 'dsr-client',
};
